import React, { useContext, useState, useEffect } from 'react';
import UserContext from '../../contexts/UserContext';
import { useNavigate ,useLocation } from 'react-router-dom';
import axios from 'axios';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

// ActiveItemsBanner Component
const ActiveItemsBanner = ({ activeItemsCount, isVisible, handleChecklistClick }) => {
  return (
    <div className={`fixed bottom-0 left-0 mb-16 w-full py-3 px-4 pb-5 bg-fmb border-t border-gray-300 transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}>
      <div className="flex justify-between items-center">
        <p className="font-semibold">Active Items: {activeItemsCount}</p>
        <button onClick={handleChecklistClick} className="bg-white font-semibold text-black px-4 py-2 rounded-md">Checklist</button>
      </div>
    </div>
  );
};

// CreateRequest Component
const CreateRequest = () => {
  const { user, setUser } = useContext(UserContext);
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const [items, setItems] = useState([]);
  const { itemsReceived } = location.state || { items: null };
  const [activeItems, setActiveItems] = useState([]);
  const [activeItemsCount, setActiveItemsCount] = useState(0);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const [message,setMessage] = useState('')
  const [quantity, setQuantity] = useState('');
  const navigate = useNavigate();
  

  useEffect(() => {
    
    async function startup() {
      if (!user) {
        
        await authenticate(setUser, navigate);
      }
      if (user) {
        console.log('itemsRecieved',itemsReceived)
        console.log('items', itemsReceived?.length>0 ? itemsReceived?.find(it=> 'Dal'===it.name):0);
        if(itemsReceived?.length>0){
         setActiveItems(itemsReceived);
         const activeCount = itemsReceived.length;
         setActiveItemsCount(activeCount);
         setIsBannerVisible(activeCount > 0);
        }
        axios.get(`${process.env.REACT_APP_API_URI}/api/items/getAll`, { withCredentials: true })
          .then(response => {
            const initialItems = response.data.data.map(item => ({ ...item, quantity: 0 }));
           
            if(itemsReceived?.length>0 ){
              
                const mergedItems = initialItems.map((item) => ({
                  ...item,
                  quantity: parseFloat(itemsReceived?.find(it => it?._id === item?._id)?.quantity).toFixed(2) || parseFloat(item.quantity).toFixed(2)
                }));
              setItems(mergedItems);  
              
            }else{
              setItems(initialItems);
            }
            
            console.log(response.data.data);
          })
          .catch((err) => {
            const errorMessage = displayError(err,navigate,setUser);
            console.log(errorMessage);
              if(errorMessage){
                setMessage(errorMessage)
              }
          })
      }
    }
    startup();
  }, [user]);
  
  const filteredItems = items?.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleQuantityChange = (id, quantity) => {
    const newQuantity = Math.max(0, Number(quantity)); // Ensure non-negative value
    const updatedItems = items.map(item =>
      item._id === id ? { ...item, quantity: newQuantity } : item
    );
    if(!isNaN(newQuantity)){
        setQuantity(newQuantity);
        
    }
    setItems(updatedItems);
    const activeCount = updatedItems?.filter(item => parseFloat(item.quantity).toFixed(2) > 0).length;
    setActiveItemsCount(activeCount);
    setIsBannerVisible(activeCount > 0);
  };

  const activeItemsList = items?.filter(item => parseFloat(item.quantity).toFixed(2) > 0).map(item => ({
    name: item.name,
    quantity: parseFloat(item.quantity).toFixed(2),
    unit: item.unit,
    _id: item._id,
    category: item.category,
    purchaseType: item.purchaseType
  }));

  const handleChecklistClick = () => {
    navigate('/zc/checklist', { state: { itemsReceived: activeItemsList } });
  };

  console.log('Active Items:', activeItemsList);

  return (
    <>
      <div className="bg-lime-800 flex items-center justify-between w-full p-4 text-white fixed z-10">
        <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Create Item Request</h4>
      </div>
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
      <div className="flex flex-col p-4 overflow-y-auto max-w-full md:max-w-4xl md:mx-auto pt-[70px]">
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="p-2 mb-4 border border-gray-300 rounded-md w-full"
        />
        <div className="space-y-2 ">
          {filteredItems?.map(item => (
            <div key={item._id} className="bg-white flex justify-between items-center p-4 shadow-md border-b border-gray-200 rounded-md">
              <div>
                <h3 className="text-[16px] font-semibold text-fmb">{item.name}</h3>
                <p className="text-gray-600">{item.category}</p>
              </div>
              <div className="flex items-center space-x-2">
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  min="0"
                  value={item.quantity|| ''}
                  onChange={(e) => handleQuantityChange(item._id, e.target.value)}
                  onFocus={(e) => handleQuantityChange(item._id, e.target.value)}
                  className="p-2 border border-gray-300 rounded-md w-20 text-center"
                />
                <span className="text-gray-600">{item.unit}</span>
              </div>
            </div>
          ))}
        </div>
        <ActiveItemsBanner activeItemsCount={activeItemsCount} isVisible={isBannerVisible} handleChecklistClick={handleChecklistClick} />
      </div>
    </>
  );
};

export default CreateRequest;